// extracted by mini-css-extract-plugin
export default {"termsContainer":"Terms_termsContainer__ymKuq","sectionHeader":"Terms_sectionHeader__wVWDN"};